import { render } from "./controlEdit.vue?vue&type=template&id=083a6d4d&scoped=true&ts=true"
import script from "./controlEdit.vue?vue&type=script&lang=ts"
export * from "./controlEdit.vue?vue&type=script&lang=ts"

import "./controlEdit.vue?vue&type=style&index=0&id=083a6d4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083a6d4d"]])

export default __exports__